import { useEffect, useState } from "react";
import { motion, useMotionValue, useSpring } from "framer-motion";

export const CustomCursor = () => {
  const [enabled, setEnabled] = useState(false);
  const [state, setState] = useState("default");
  const x = useMotionValue(-100);
  const y = useMotionValue(-100);
  const sx = useSpring(x, { stiffness: 500, damping: 45, mass: 0.4 });
  const sy = useSpring(y, { stiffness: 500, damping: 45, mass: 0.4 });

  useEffect(() => {
    if (window.matchMedia("(pointer: coarse)").matches) return;
    setEnabled(true);
    document.documentElement.classList.add("has-custom-cursor");
    const move = (e) => {
      x.set(e.clientX);
      y.set(e.clientY);
    };
    const over = (e) => {
      const t = e.target.closest("a, button, [data-cursor]");
      if (!t) return setState("default");
      setState(t.dataset.cursor || (t.tagName === "A" ? "link" : "cta"));
    };
    window.addEventListener("mousemove", move, { passive: true });
    document.addEventListener("mouseover", over, { passive: true });
    return () => {
      document.documentElement.classList.remove("has-custom-cursor");
      window.removeEventListener("mousemove", move);
      document.removeEventListener("mouseover", over);
    };
  }, [x, y]);

  if (!enabled) return null;

  const size = state === "cta" ? 56 : state === "link" ? 36 : 14;
  return (
    <motion.div
      aria-hidden="true"
      data-testid="custom-cursor"
      className="fixed top-0 left-0 z-[100] pointer-events-none hidden md:block"
      style={{ x: sx, y: sy }}
    >
      <motion.div
        className="rounded-full -translate-x-1/2 -translate-y-1/2"
        animate={{
          width: size,
          height: size,
          backgroundColor: state === "cta" ? "rgba(0,199,165,0.12)" : "rgba(0,217,255,0.05)",
          borderColor: state === "default" ? "rgba(0,217,255,0.7)" : "rgba(0,199,165,0.9)",
        }}
        transition={{ type: "spring", stiffness: 400, damping: 28 }}
        style={{ borderWidth: 1.5, boxShadow: state === "cta" ? "0 0 30px rgba(0,199,165,0.35)" : "none" }}
      />
    </motion.div>
  );
};
